var render, staticRenderFns
import script from "./contact_info_item.vue?vue&type=script&lang=js"
export * from "./contact_info_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29bc8b8e')) {
      api.createRecord('29bc8b8e', component.options)
    } else {
      api.reload('29bc8b8e', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/contact_info/contact_info_item.vue"
export default component.exports